import React from "react";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import euCoFlag from "assets/footer_images/EN_Co-fundedbytheEU_RGB_POS.png";
import ukriLogo from "assets/footer_images/UKRI logo.png";
import wbfLogo from "assets/footer_images/WBF_SBFI_EU_Frameworkprogramme_E_RGB_neg_quer.png";
import styles from "./Footer.module.css"; 

const LEGAL_LINKS = [
    { to: "/legal", label: "Legal & Privacy" },
    { to: "/terms", label: "Terms of Use" },
    { to: "/privacy", label: "Privacy Notice" },
    { to: "/cookies", label: "Cookie & Storage Policy" },
    { to: "/accessibility", label: "Accessibility" },
];

const Footer = () => {
    const { t } = useTranslation();

    return (
        <footer className={styles.footerContainer}>
            <div className={styles.content}>
                <img src={euCoFlag} alt="EU Flag" className={styles.euFlag} />
                <img src={ukriLogo} alt="UKRI Logo" className={styles.ukriLogo} />
                <img src={wbfLogo} alt="WBF Logo" className={styles.wbfLogo} />
                <Typography variant="body2" className={styles.text}>
                    {t('footer.disclaimer')}
                </Typography>
            </div>
            <nav className={styles.legalLinks} aria-label="Legal">
                {LEGAL_LINKS.map((link) => (
                    <Link key={link.to} to={link.to} className={styles.legalLink}>
                        {link.label}
                    </Link>
                ))}
            </nav>
        </footer>
    );
};

export default Footer;
